import axios from "axios";
import { CURRENT_API_URL } from "../../../Utils/Constants";
import notify from "../../../Notifications/ToastifyActions";

function FetchFbaInventorySummaryService(token, data) {

    return axios.post(`${CURRENT_API_URL}/sellerPartner/fetchFbaInventorySummary`, data,
            {
                headers: {
                    Authorization: token,
                },
            }
        )
        .then((res) => {
            return res.data;
        })
        .catch((error) => {
            console.log(error);
            notify.NotifyError(
                "An error occurred while fetching FBA Inventory. Please try again later."
            );
            return false;
        });
}

export default FetchFbaInventorySummaryService;
